/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const InstitutionIcon = /*#__PURE__*/ createSvgIcon(
  'InstitutionIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4 13.75v-5c0-.213.071-.39.214-.534A.72.72 0 014.746 8c.21 0 .39.072.535.216a.72.72 0 01.219.534v5c0 .213-.071.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216A.72.72 0 014 13.75zm5.25 0v-5c0-.213.071-.39.214-.534A.72.72 0 019.996 8c.21 0 .39.072.535.216a.72.72 0 01.219.534v5c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534zM2.75 17a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h14.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H2.75zm11.75-3.25v-5c0-.213.072-.39.214-.534A.72.72 0 0115.246 8c.21 0 .39.072.535.216A.72.72 0 0116 8.75v5c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534zM17 7H2.896a.866.866 0 01-.635-.26A.859.859 0 012 6.108v-.546c0-.166.045-.326.135-.479A.804.804 0 012.5 4.75l6.833-3.417c.21-.11.432-.166.667-.166.235 0 .457.055.667.166l6.791 3.396a.985.985 0 01.542.886V6c0 .283-.096.52-.288.712A.968.968 0 0117 7zM4.354 5.5h11.292L10 2.687 4.354 5.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default InstitutionIcon;
